import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Utils } from '../utils';

@Injectable()
export class AuthChangePasswordGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (Utils.isUserLogged())
      return true;

    // not logged in so redirect to login page with the return url
    this.router.navigate([ '/login' ], { queryParams: { returnUrl: state.url }});
    return false;
  }
  
}


// WEBPACK FOOTER //
// ./src/app/_guard/auth-change-password.guard.ts